import axios from "axios";

export default {
  data() {
    return {
      stay: {
        person: null,
        start_date: null,
        end_date: null,
        type: "other",
        organization: null,
        responsible: "",
        description: "",
        funder_program: null,
        funding_comments: "",
      }
    };
  },

  methods: {
    getStay(path) {
      axios
        .get(path)
        .then(response => {
          this.stay = response.data;
        })
        .finally(() => (this.load_complete = true))
        .catch(error => {
          console.log(error);
        });
    },
    setBreadcrumb() {

      this.$store.state.sectionTitle = "...";

      const path =
        this.$store.state.endpoint + "/person/" + this.stay.person;
      axios
        .get(path)
        .then(response => {
          const p = response.data.preferred_name;
          const n = `${p.given_name} ${p.family_name}`;
          this.$store.state.sectionTitle = n;

          let item = {
            text: n,
            disabled: true,
            last: true
          };
          if (
            !this.$route.meta.breadCrumb.some(breadcrumb => {
              return breadcrumb.last === true;
            })
          ) {
            this.$route.meta.breadCrumb.push(item);
          } else {
            this.$route.meta.breadCrumb.pop();
            this.$route.meta.breadCrumb.push(item);
          }

        })
        .catch(error => {
          console.log(error);
        });
      
    },
    getStayWithBreadCrumb(path) {
      axios
        .get(path)
        .then(response => {
          this.stay = response.data;
        })
        .finally(() => this.setBreadcrumb())
        .catch(error => {
          console.log(error);
        });
    }
  }
};
